/**
 * 플랫폼 관련 상수 정의
 */

/**
 * 플랫폼별 한글 라벨
 */
export enum PlatformLabel {
  MUSINSA = '무신사',
  EGOOCM = '29CM',
  // SOLDOUT = 'SOLDOUT', // TODO: Phase2 추가예정
}

/**
 * 플랫폼 코드
 */
export enum Platform {
  MUSINSA = 'MUSINSA',
  EGOOCM = 'EGOOCM',
  // SOLDOUT = 'SOLDOUT', // TODO: Phase2 추가예정
}
